import { render, staticRenderFns } from "./RightsForm.vue?vue&type=template&id=79604c04"
import script from "./RightsForm.vue?vue&type=script&lang=js"
export * from "./RightsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports